<template>
  <div class="user-kit-item item-menu-holding">
    <div class="img-userkit">
      <img :src="imagePath" :alt="imageAlt" class="user-kit-icon">
    </div>
    <div class="title-userkit">{{title}}</div>
  </div>
</template>

<script>
  export default {
    name: 'UserKitItem',
    props: ['imagePath', 'imageAlt', 'title']
  }
</script>

<style>
  .img-userkit {
    max-width: 75px;
    margin-left: auto;
    margin-right: auto;
  }

  .img-userkit > img {
    width: 50%;
  }

  .title-userkit {
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/dashboard/manager/UserKitItem.vue